<template>
  <div class="gridMainLayout">
    <div class="gridContainer" :class="{ 'portrait': displayType === 'PORTRAIT', 'landscape': displayType === 'LANDSCAPE' }">
      <div class="gridCardWrapper gridCardWrapper-loader" v-for="(item, index) in continueData" :key="index">
        <div class="continueWatchCard gridCardLayout">
          <div class="gridPosterLayout loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['displayType'],
  data() {
    return {
      continueData: 8
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
@import "@/components/Templates/Grid.scss";
</style>
